import { removeObjectInArray, updateObjectsInArray } from 'shared/lib/array';

// TODO: remove once users, goals, updates and pins are in nebula
export const updatePropertyOptions = (state, propertyOptions) => {
  const updateOptionsInState = (options) => {
    state.goals.forEach((u) => {
      u.properties.forEach((v) => {
        if (v.selectedOptions === undefined) {
          return;
        }
        updateObjectsInArray(v.selectedOptions, options);
      });
    });
  };

  propertyOptions.forEach((entity) => {
    const optionsToUpdate = entity.parents.reduce((acc, next) => {
      // only update 'full' objects
      if (typeof next.label === 'undefined') {
        return acc;
      }
      return [...acc, next];
    }, [entity]);

    updateOptionsInState(optionsToUpdate);
  });
};

// TODO: remove once users, goals, updates and pins are in nebula
export const deletePropertyOption = (state, entity) => {
  state.goals.forEach((u) => {
    u.properties.forEach((v) => {
      if (v.selectedOptions === undefined) {
        return;
      }
      removeObjectInArray(v.selectedOptions, entity);
    });
  });
};
